export default __webpack_public_path__ + "static/media/background.f4e2af63.jpeg";